import '../Assests/css/views/projects.css';
import Card from '../Components/Cards'; 
export default function Projects() {
    return (
        <section id="projects" className="projects">
            <div>
                <h1>PROJECTS</h1>
                <p>Here are some of my featured projects that showcase my skills in full-stack development, AI integration, and modern web technologies. Each project represents a unique challenge and learning experience.</p>

                <ul className="project-list">
                    <Card title="Emoticoach" description="AI-powered emotional writing companion using Emotional RAG and FastAPI." githubLink="https://github.com/Lorieta/emoticoach1" imageUrl="https://res.cloudinary.com/dttgvr9lo/image/upload/v1771848603/Gemini_Generated_Image_grshdugrshdugrsh_b2q57k.png"/>
                    <Card title="Recipe AI App" description="Community-driven recipe platform with AI-based recommendations." githubLink="https://github.com/Lorieta/MVCPrject" imageUrl="https://res.cloudinary.com/dttgvr9lo/image/upload/v1771850338/image_e4fnhi.png"/>
                    <Card title="Ruby Graphql POS system" description="A point-of-sale system built with Ruby and GraphQL." githubLink="https://github.com/Lorieta/POS" imageUrl="https://res.cloudinary.com/dttgvr9lo/image/upload/v1771848732/Gemini_Generated_Image_dn0p3ldn0p3ldn0p_krisz7.png"/>
                </ul>
            </div>
        </section>
    );
}